import { Injectable } from "@angular/core";
import { TenantContextService } from "./tenant-context.service";
import { GeneralSettingsService } from "./general-settings.service";
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root',
})
export class TenantRedirectService {

  constructor(
    private tenantContextService: TenantContextService
  ) {}

  enforceTenantDomain(): void {

    const loginAlias = this.tenantContextService.getLoginAlias();
    const targetTenant =
      loginAlias || environment.defaultTenant;

    const currentHost: string = window.location.hostname;
    const currentTenant = this.getTenantFromHost(currentHost);

    if (!currentTenant) return;
    if (currentTenant === targetTenant) return;

    const targetUrl =
      `https://${targetTenant}.${environment.rootDomain}` +
      window.location.pathname +
      window.location.search;

    window.location.href = targetUrl;
  }

  private getTenantFromHost(host: string): string | null {
    if (host === 'localhost') return null;
    if (!host.endsWith(environment.rootDomain)) return null;

    return host.replace(`.${environment.rootDomain}`, '');
  };
}